import { z } from 'zod';

export const ReportRsSchema = z.object({
  year: z.number({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
  percentage: z
    .number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    })
    .min(0, 'minValue')
    .max(100, 'maxValue'),
  projectName: z.string({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
});

export type ReportRsFormData = z.infer<typeof ReportRsSchema>;
